import {
  BOT_TYPE_COMPLIANCE,
  BOT_TYPE_SECURITY,
  ACTIVE,
} from "../../utils/app-constants.json";
import { securityBotmessages, complianceBotMessages } from "./bots-insights";
import {faker}  from "@faker-js/faker";
import moment from "moment";
import defaultValuesOld from "../scenarios/edu-scenarios";
import { isArrayWithLength } from "../../utils/array-methods";

export const top5SecurityVoilatingRules = (botType) => {
  const isComplianceBot = botType === BOT_TYPE_COMPLIANCE;
  return [
    {
      [securityBotmessages.S3[1]]: {
        Count: 10,
        ResourceType: isComplianceBot ? "S3" : "AwsS3Bucket",
      },
    },
    {
      [securityBotmessages.Rds[1]]: {
        Count: 8,
        ResourceType: isComplianceBot ? "S3" : "AwsS3Bucket",
      },
    },
    {
      [securityBotmessages.IAMUser[0]]: {
        Count: 8,
        ResourceType: isComplianceBot ? "IAMUser" : "AwsIamUser",
      },
    },
    {
      [securityBotmessages.Rds[0]]: {
        Count: 4,
        ResourceType: isComplianceBot ? "S3" : "AwsS3Bucket",
      },
    },
    {
      [securityBotmessages.SecurityGroup[0]]: {
        Count: 4,
        ResourceType: isComplianceBot ? "SecurityGroup" : "AwsEc2SecurityGroup",
      },
    },
  ];
};

export const top5ComplianceVoilatingRules = (botType) => {
  const isComplianceBot = botType === BOT_TYPE_COMPLIANCE;
  return [
    {
      [complianceBotMessages.S3[0]]: {
        Count: 12,
        ResourceType: isComplianceBot ? "S3" : "AwsS3Bucket",
      },
    },
    {
      [complianceBotMessages.IamAccessKey[1]]: {
        Count: 9,
        ResourceType: isComplianceBot ? "IamAccessKey" : "AwsIamAccessKey",
      },
    },
    {
      [complianceBotMessages.Volume[1]]: {
        Count: 8,
        ResourceType: isComplianceBot ? "Volume" : "AwsEc2Volume",
      },
    },
    {
      [complianceBotMessages.DynamoDbTable[6]]: {
        Count: 8,
        ResourceType: isComplianceBot ? "DynamoDbTable" : "AwsDynamoDbTable",
      },
    },
    {
      [complianceBotMessages.S3[4]]: {
        Count: 4,
        ResourceType: isComplianceBot ? "S3" : "AwsS3Bucket",
      },
    },
  ];
};

const top5VoilatingObjects = (botInsights, botType) => {
  const instances = botInsights.filter((i) => i.ResourceType === "Instance");
  const accounts = botInsights.filter((i) => i.ResourceType === "Account");
  const s3 = botInsights.filter((i) => i.ResourceType === "S3");
  const vpc = botInsights.filter((i) => i.ResourceType === "Vpc");
  const isComplianceBot = botType === BOT_TYPE_COMPLIANCE;
  return [
    {
      [instances[0].ResourceId]: {
        Count: 8,
        ResourceType: isComplianceBot ? "Instance" : "AwsEc2Instance",
      },
    },
    {
      [accounts[0].ResourceId]: {
        Count: 5,
        ResourceType: isComplianceBot ? "Account" : "AwsAccount",
      },
    },
    {
      [s3[0].ResourceId]: {
        Count: 4,
        ResourceType: isComplianceBot ? "S3" : "AwsS3Bucket",
      },
    },
    {
      [vpc[2].ResourceId]: {
        Count: 2,
        ResourceType: isComplianceBot ? "Vpc" : "AwsEc2Vpc",
      },
    },
    {
      [accounts[1].ResourceId]: {
        Count: 2,
        ResourceType: isComplianceBot ? "Account" : "AwsAccount",
      },
    },
  ];
};

const getStatusCount = (
  botType,
  passedCount,
  failedCount,
  industryStandardName
) => {
  return botType === BOT_TYPE_COMPLIANCE
    ? {
        CompliantCount: passedCount,
        NonCompliantCount: failedCount,
        IndustryStandard: industryStandardName,
      }
    : { Passed: passedCount, Failed: failedCount };
};

const industryStandards = (botType) => {
  return [
    getStatusCount(botType, 23, 6, "CIS"),
    getStatusCount(botType, 33, 10, "HIPAA"),
    getStatusCount(botType, 26, 27, "NIST"),
    getStatusCount(botType, 22, 12, "FedRAMP"),
    getStatusCount(botType, 25, 10, "PCI"),
  ];
};

const getResourceTypes = (botType) => {
  const isComplianceBot = botType === BOT_TYPE_COMPLIANCE;
  return isComplianceBot
    ? [
        {
          ResourceType: "S3 Bucket",
          Status: { Compliance: 9, NonCompliance: 5 },
        },
        {
          ResourceType: "RDS DB Instance",
          Status: { Compliance: 16, NonCompliance: 9 },
        },
        {
          ResourceType: "Volume",
          Status: { Compliance: 10, NonCompliance: 5 },
        },
        {
          ResourceType: "IAM Access Key",
          Status: { Compliance: 7, NonCompliance: 5 },
        },
      ]
    : [
        {
          ResourceType: "Security Group",
          Status: { Passed: 7, Failed: 2 },
        },
        {
          ResourceType: "S3 Bucket",
          Status: { Passed: 3, Failed: 2 },
        },
        {
          ResourceType: "RDS DB Instance",
          Status: { Passed: 6, Failed: 4 },
        },
        {
          ResourceType: "Glue Data Catalog",
          Status: { Passed: 7, Failed: 1 },
        },
      ];
};

export const getBotSummary = async (botType, botInsights) => {
  const isComplianceBot = botType === BOT_TYPE_COMPLIANCE;
  const status = isComplianceBot
    ? { Compliance: 129, NonCompliance: 40 }
    : { Passed: 139, Failed: 150, Suppressed: 20 };
  const summary = {
    OpenIssues: isComplianceBot ? 40 : 150,
    LastRun: moment(new Date())
      .subtract(faker.number.int({ max: 40, min: 10 }), "m")
      .toDate(),
    Status: ACTIVE,
    Findings: isComplianceBot
      ? top5ComplianceVoilatingRules(botType)
      : top5SecurityVoilatingRules(botType),
    Resources: top5VoilatingObjects(botInsights, botType),
    ...(isComplianceBot && {
      IndustryStandards: industryStandards(botType),
    }),
    ...(botType === BOT_TYPE_SECURITY && {
      BySeverity: {
        Critical: { Passed: 29, Failed: 11 },
        High: { Passed: 34, Failed: 15 },
        Informational: { Passed: 36, Failed: 10 },
        Medium: { Passed: 33, Failed: 4 },
        Low: { Passed: 27, Failed: 9 },
      },
    }),
    ByStatus: status,
    ByResourceType: getResourceTypes(botType),
  };

  return summary;
};

export const getBotOpsSummary = (deptId, appId) => {
  let applications = defaultValuesOld().allApplications;
  let securityOpenIssues = 150;
  let complianceOpenIssues = 40;
  if (isArrayWithLength(applications)) {
    if (isArrayWithLength(deptId) && !appId) {
      applications = applications.filter(
        (app) => app.DepartmentId === deptId[0]
      );
      securityOpenIssues =
        isArrayWithLength(applications) &&
        applications
          .map((app) => app.SecurityBotOpenIssues)
          .reduce((prev, next) => prev + next);
      complianceOpenIssues =
        isArrayWithLength(applications) &&
        applications
          .map((app) => app.ComplianceBotOpenIssues)
          .reduce((prev, next) => prev + next);
    } else if (isArrayWithLength(appId)) {
      const app = applications.find((app) => app.ID === appId[0]);
      securityOpenIssues = app.SecurityBotOpenIssues;
      complianceOpenIssues = app.ComplianceBotOpenIssues;
    }
  }
  return {
    SecurityBotOpenIssues: securityOpenIssues,
    SecurityBotRecommendation: 25,
    ComplianceBotOpenIssues: complianceOpenIssues,
    ComplianceBotRecommendation: 15,
    SecurityBotRemediation: 43,
    ComplianceBotRemediation: 37,
  };
};
